(() => {
  if (window.voltCatalogReady) return;
  window.voltCatalogReady = true;
  const fold = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('ro');
  function initDirectory(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-category-search]');
    const cards = [...root.querySelectorAll('[data-category-card]')];
    const buttons = [...root.querySelectorAll('[data-group-filter]')];
    const empty = root.querySelector('[data-category-empty]');
    let group = 'all';
    const filter = () => {
      const query = fold(input.value.trim());
      let count = 0;
      cards.forEach(card => {
        const match = (group === 'all' || card.dataset.group === group) && fold(card.textContent).includes(query);
        card.hidden = !match;
        if (match) count++;
      });
      empty.hidden = count !== 0;
    };
    input.addEventListener('input', filter);
    buttons.forEach(button => button.addEventListener('click', () => {
      group = button.dataset.groupFilter;
      buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      filter();
    }));
    root.querySelector('[data-clear-search]').addEventListener('click', () => {
      input.value = '';
      group = 'all';
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.groupFilter === 'all')));
      filter();
      input.focus();
    });
    root.querySelector('[data-directory-tools]').hidden = false;
  }
  function init() {
    document.querySelectorAll('[data-category-directory]').forEach(initDirectory);
  }
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-volt-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    const menu = event.target.closest('[data-volt-menu]');
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-volt-menu][open]').forEach(openMenu => {
        const restore = openMenu.contains(document.activeElement);
        openMenu.open = false;
        if (restore) openMenu.querySelector('summary').focus();
      });
    }
    if (menu && event.key === 'ArrowDown' && event.target === menu.querySelector('summary')) {
      event.preventDefault();
      menu.open = true;
      menu.querySelector('a').focus();
    }
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-volt-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();

(() => {
  function initSubcategories() {
    const nav = document.querySelector('[data-subcategory-nav]');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    fetch(nav.dataset.source, { credentials: 'same-origin' })
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(data => {
        const nodes = data.nodes || [];
        const currentHandle = nav.dataset.currentHandle;
        const current = nodes.find(item => item.handle === currentHandle);
        const branch = current ? current.handle : currentHandle;
        let options = nodes.filter(item => item.parent === branch);
        if (!options.length && current) options = nodes.filter(item => item.parent === current.parent);
        if (!options.length) return;
        const wrap = document.createElement('div');
        wrap.className = 'vc-subcategory-inner';
        const copy = document.createElement('div');
        copy.className = 'vc-subcategory-copy';
        const heading = document.createElement('h2');
        heading.textContent = current && nodes.some(item => item.parent === current.handle)
          ? nav.dataset.childrenLabel : nav.dataset.label;
        copy.append(heading);
        if (current) {
          const parent = document.createElement('a');
          parent.className = 'vc-subcategory-parent';
          parent.href = `/collections/${current.parent}`;
          parent.textContent = `${nav.dataset.backLabel} ${current.parentTitle}`;
          copy.append(parent);
        }
        wrap.append(copy);
        const links = document.createElement('div');
        links.className = 'vc-subcategory-links';
        options.forEach(item => {
          const link = document.createElement('a');
          link.href = `/collections/${item.handle}`;
          link.textContent = item.title;
          if (item.handle === currentHandle) link.setAttribute('aria-current', 'page');
          links.append(link);
        });
        wrap.append(links);
        const picker = document.createElement('label');
        picker.className = 'vc-subcategory-picker';
        const pickerText = document.createElement('span');
        pickerText.textContent = nav.dataset.selectLabel;
        const select = document.createElement('select');
        select.setAttribute('aria-label', nav.dataset.selectLabel);
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = nav.dataset.selectLabel;
        select.append(placeholder);
        options.forEach(item => {
          const option = document.createElement('option');
          option.value = `/collections/${item.handle}`;
          option.textContent = item.title;
          option.selected = item.handle === currentHandle;
          select.append(option);
        });
        select.addEventListener('change', () => { if (select.value) window.location.assign(select.value); });
        picker.append(pickerText, select);
        wrap.append(picker);
        nav.replaceChildren(wrap);
        nav.hidden = false;
      }).catch(() => { nav.hidden = true; });
  }
  document.addEventListener('DOMContentLoaded', initSubcategories);
  document.addEventListener('shopify:section:load', initSubcategories);
  initSubcategories();
})();
